import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Modal from '../../../../common/modal'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../../common/snippets'
import { UserRollRightPageTabIds, UserRollRightsPageTab, URRBRMidLeftDropData, URRBRMidLeftDropDataV2 } from '../../constants'
import LuggageBookingRights from './LuggageBookingRights'
import CashBookRights from './CashBookRights'

const LuggageRightsModal = (props) => {
    const { data, updateModal, luggageRightsData, otpOnUserRights, roleId, loginData } = props
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        paddingTop: '5%'
    }
    const [selectedTab, setSelectedTab] = useState(0)
    const [showCheckValue, setCheckValue] = useState({
        AllowCBBankPay: 0, AllowCBEntryOwnBranch: 0, AllowCBBankReceive: 0, AllowCBEntryAllBranch: 0,
        AllowCBLadgerPay: 0, AllowCBEntryFranchise: 0, AllowCBLadgerReceive: 0, AllowCBBankToBank: 0
    })
    const [luggageRightsValue, setLuggageRightsValue] = useState({
        AllowAdminCancelDispatch: 0, AllowAdminCancelReceive: 0, AllowAdminDestinationChange: 0, AllowAdminDispatchChange: 0, AllowAdminSendAndRecChange: 0, AllowAllBranchLRCancel: 0,
        AllowBranchDetSMS: 0, AllowBranchInchargeRights: 0, AllowCancelThruAnyBrAndUser: 0, AllowDelChgChange: 0, AllowDeliveryDisc: 0, AllowDemChgChange: 0, AllowDispatchGodown: 0, AllowExportExcel: 0, AllowPrintandPdf: 0,
        AllowFareChange: 0, AllowHamaliEdit: 0, AllowLitReceive: 0, AllowOperatorHamaliEdit: 0, AllowPartyBooking: 0, AllowPartyVoucher: 0, AllowReprint: 0, AllowRollBack: 0, AllowShortReceipt: 0, AllowShowAdditional: 0, AllowUpdate: 0, AllowUpdateAll: 0,
        AllowUpdateBtn: 0, AllowUpdateOtherBranches: 0, AllowUserChangeBranch: 0, AllowUserViewAllDelivery: 0, AllowViewAllBranchOfCityReport: 0, AllowViewAllBranchReport: 0, IsBookingRCM: 0, IsDeliveryRCM: 0, LimitOnDelChange: 0, LimitOnDemChange: 0, LimitOnFareChange: 0, LimitOnFareChangePer: 0, MaxHamaliPerLR: 0,
        MaxHamaliPerUnit: 0, MaxOperatorHamaliPerLR: 0, MaxOperatorHamaliPerUnit: 0, DisallowFareReduction: 0, AllowExportCommission: 0,AllowBranchselection:0,DashboardAccessLevel:0,
    })
    const [luggageTableData, setLuggageTableData] = useState([])
    useEffect(() => {
        if (luggageRightsData?.Table1?.length > 0) {
            const obj = luggageRightsData?.Table1?.[0] || {}
            setCheckValue((prev) => ({
                ...prev, AllowCBBankPay: luggageRightsData?.Table1?.[0]?.AllowCBBankPay, AllowCBEntryOwnBranch: luggageRightsData?.Table1?.[0]?.AllowCBEntryOwnBranch, AllowCBBankReceive: luggageRightsData?.Table1?.[0]?.AllowCBBankReceive, AllowCBEntryAllBranch: luggageRightsData?.Table1?.[0]?.AllowCBEntryAllBranch,
                AllowCBLadgerPay: luggageRightsData?.Table1?.[0]?.AllowCBLadgerPay, AllowCBEntryFranchise: luggageRightsData?.Table1?.[0]?.AllowCBEntryFranchise, AllowCBLadgerReceive: luggageRightsData?.Table1?.[0]?.AllowCBLadgerReceive, AllowCBBankToBank: luggageRightsData?.Table1?.[0]?.AllowCBBankToBank
            }))
            let luggageValue = { ...luggageRightsValue };
            for (const key in luggageValue) {
                luggageValue[key] = obj[key];
            }
            setLuggageRightsValue({
                ...luggageValue, AllowFareChange: URRBRMidLeftDropData.filter((val) => val.dropId == obj.AllowFareChange)?.[0] || "", AllowHamaliEdit: URRBRMidLeftDropData.filter((val) => val.dropId == obj.AllowHamaliEdit)?.[0] || "",
                AllowOperatorHamaliEdit: URRBRMidLeftDropData.filter((val) => val.dropId == obj.AllowOperatorHamaliEdit)?.[0] || "", AllowDelChgChange: URRBRMidLeftDropDataV2?.filter((val) => val.dropId == obj.AllowDelChgChange)?.[0] || "", AllowDemChgChange: URRBRMidLeftDropDataV2?.filter((val) => val.dropId == obj.AllowDemChgChange)?.[0] || "",

                AllowAdminCancelDispatch: obj?.AllowAdminCancelDispatch, AllowAdminCancelReceive: obj?.AllowAdminCancelReceive, AllowAdminDestinationChange: obj?.AllowAdminDestinationChange, AllowAdminDispatchChange: obj?.AllowAdminDispatchChange, AllowAdminSendAndRecChange: obj?.AllowAdminSendAndRecChange, AllowAllBranchLRCancel: obj?.AllowAllBranchLRCancel,
                AllowBranchDetSMS: obj.AllowBranchDetSMS, AllowBranchInchargeRights: obj.AllowBranchInchargeRights, AllowCancelThruAnyBrAndUser: obj?.AllowCancelThruAnyBrAndUser, AllowDeliveryDisc: obj?.AllowDeliveryDisc, AllowDispatchGodown: obj?.AllowDispatchGodown, AllowExportExcel: obj?.AllowExportExcel, AllowPrintandPdf: obj?.AllowPrintandPdf,
                AllowLitReceive: obj.AllowLitReceive, AllowPartyBooking: obj?.AllowPartyBooking, AllowPartyVoucher: obj?.AllowPartyVoucher, AllowReprint: obj?.AllowReprint, AllowRollBack: obj.AllowRollBack, AllowShortReceipt: obj?.AllowShortReceipt, AllowShowAdditional: obj?.AllowShowAdditional, AllowUpdate: obj.AllowUpdate, AllowUpdateAll: obj?.AllowUpdateAll,
                AllowUpdateBtn: 0, AllowUpdateOtherBranches: obj?.AllowUpdateOtherBranches, AllowUserChangeBranch: obj?.AllowUserChangeBranch, AllowUserViewAllDelivery: obj?.AllowUserViewAllDelivery, AllowViewAllBranchOfCityReport: obj?.AllowViewAllBranchOfCityReport, AllowViewAllBranchReport: obj?.AllowViewAllBranchReport, IsBookingRCM: obj?.IsBookingRCM, IsDeliveryRCM: obj?.IsDeliveryRCM, LimitOnDelChange: obj?.LimitOnDelChange, LimitOnDemChange: obj?.LimitOnDemChange, LimitOnFareChange: obj?.LimitOnFareChange, LimitOnFareChangePer: obj?.LimitOnFareChangePer, MaxHamaliPerLR: obj?.MaxHamaliPerLR,
                MaxHamaliPerUnit: obj?.MaxHamaliPerUnit, MaxOperatorHamaliPerLR: obj?.MaxOperatorHamaliPerLR, MaxOperatorHamaliPerUnit: obj?.MaxOperatorHamaliPerUnit, AllowMarkAsLost: obj?.AllowMarkAsLost, DisallowFareReduction: obj?.DisallowFareReduction, AllowExportCommission: obj?.AllowExportCommission , AllowGroupofCompanies:obj?.AllowGroupofCompanies,DashboardAccessLevel:obj?.DashboardAccessLevel
            })
        }
        if (luggageRightsData?.Table?.length > 0) {
            const updatedData = luggageRightsData?.Table?.map((val) => [1, 2, 6].includes(val.BookingRightsID) ? ({ ...val, Allowed: 1 }) : val)
            setLuggageTableData(updatedData)
        } else {
            setLuggageTableData([])
        }
    }, [luggageRightsData])


    const getBookingPageContent = (typeId, label) => {
        switch (typeId) {
            case 0:
                return <LuggageBookingRights luggageRightsValue={luggageRightsValue} setLuggageRightsValue={setLuggageRightsValue} luggageTableData={luggageTableData} setLuggageTableData={setLuggageTableData} otpOnUserRights={otpOnUserRights} roleId={roleId} loginData={loginData} />
            case 1:
                return <CashBookRights otpOnUserRights={otpOnUserRights} setCheckValue={setCheckValue} showCheckValue={showCheckValue} roleId={roleId} loginData={loginData} />
            default:
                return label
        }
    }
    return (
        <Modal headTxt={`Luggage Rights`} modalStyle={modalStyle} modalClass={'booking-popup'} width={'90%'} closeId={"closeButton"} updateModal={updateModal} >
            <Box className="BranchPageTabContainer LuggageRightsModal scrollBlue" sx={{ maxHeight: '85vh', overflowY: 'auto' }}>
                <Item sx={{ paddingTop: 0, paddingX: 0 }}>
                    <Box sx={{
                        paddingX: '15px', borderBottom: 1, borderColor: 'divider', backgroundColor: '#F2F9FF !important',
                        position: 'sticky',
                        top: 0,
                        zIndex: 6,
                    }}>
                        <Tabs
                            value={selectedTab}
                            variant="scrollable"
                            aria-label="bsic tabs example"
                            sx={{
                                minHeight: 'unset',
                                alignItems: 'center',

                            }}
                            onChange={(e, newValue) => setSelectedTab(newValue)}
                        >
                            {UserRollRightsPageTab.map((reqType, index) => (
                                <Tab key={`sender_${index}`} label={reqType} {...UserRollRightPageTabIds(index)} />
                            ))}
                        </Tabs>
                    </Box>
                    {UserRollRightsPageTab.map((reqType, index) => (
                        <div
                            role="tabpanel"
                            hidden={selectedTab !== index}
                            id={`bookingPage-tabpanel-${index}`}
                            aria-labelledby={`bookingPage-tab-${index}`}
                            key={`senderSe_${index}`}
                        >
                            {selectedTab === index && <Box>{getBookingPageContent(index, reqType)}</Box>}
                        </div>
                    ))}
                </Item>
            </Box>
        </Modal>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError,
}

export default connect(mapStateToProps, mapDispatchToProps)(LuggageRightsModal)